import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: '/admin/transfer/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/transfer/create',
      data,
      dataType: 'form'
    });
  },
  getCoinTypes() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  }
};
